<section class="page-content d-flex justify-content-center align-items-center p-5">
    <!-- <button *ngIf="!isAuthenticated" (click)="login()">Login with Entra ID</button>
    <button *ngIf="isAuthenticated" (click)="logout()">Logout</button>
    <div *ngIf="isAuthenticated">
      <h3>Welcome, {{ userName }}</h3>
    </div> -->
  </section>
  
  <span class="version">{{ environment }} - {{ releaseNumber }}</span>